import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import {SpesenItem} from '../../spesen.model';
import {BestaetigungsFormComponent} from '../../../../ui-components/bestaetigungs-form/bestaetigungs-form.component';
import {deleteZeitStart} from '../../store/actions/Zeit-del.actions';
import {MatDialog} from '@angular/material/dialog';
import {select, Store} from '@ngrx/store';
import {Zeitstate} from '../../store/reducer/zeiterfassung.reducer';
import {deleteSpeseStart} from '../../store/actions/spese-del.actions';
import {SpesenFormdialogComponent} from '../spesen-form-dialog/spesen-formdialog.component';
import {SpesenartItem} from '../../spesenart.model';
import {deleteSpesenartStart} from '../../store/actions/spesenart-del.actions';
import {ZeiterfassungFormdialogNeuComponent} from '../zeiterfassung-formdialog-neu/zeiterfassung-formdialog-neu.component';
import {SpesenartFormdialogComponent} from '../spesenart-form-dialog/spesenart-formdialog.component';
import {deleteDashboardStart} from '../../../landingpage/store/actions/dashboard-del.actions';
import {activateSpesenartStart} from '../../store/actions/spesenart-activate.actions';
import {deactivateSpesenartStart} from '../../store/actions/spesenart-deactivate.actions';

@Component({
    selector: 'app-spesenart-table',
    templateUrl: './spesenart-table.component.html',
    styleUrls: ['./spesenart-table.component.scss'],
})
export class SpesenartTableComponent implements OnInit {
  public displayedColumns: string[] = [
    'code',
    'bezeichnung',
    'ansatzInt',
    'ansatzExt',
    'konto',
    'actions',
  ];

  public dataSource = new MatTableDataSource<SpesenartItem>();

  constructor( public dialog: MatDialog , public store: Store<{ zeiterfassung: Zeitstate }> ) {
  }

  @Input()
  public showFunctionMenu = true;

  @Input()
  public zeitId: number;

  /**
   * Sets addresses to datasource
   *
   * @param addresses - The addresses
   */
  @Input()
  public set spesenart(spesenart: SpesenartItem[]) {
    this.dataSource.data = spesenart;
  }


    public ngOnInit(): void {}

  public editSpesenart(spesenArt: SpesenartItem): void {
    this.dialog.open(SpesenartFormdialogComponent, {
      data: {
        title: 'pages.zeitverwaltung.spesenartDialog.editTitle',
        submitButtonLabel: 'pages.addTimeDialog.submitButtonLabel',
        cancelButtonLabel: 'pages.addTimeDialog.cancelButtonLabel',
        code: spesenArt.code,
        bezeichnung: spesenArt.bezeichnung,
        ansatzInt: spesenArt.ansatzInt,
        ansatzExt: spesenArt.ansatzExt,
        konto: spesenArt.konto,
        firmaId: spesenArt.firmaId,
        id: spesenArt.id,
        projektId: spesenArt.projekt,
      },
    });
  }

  public deleteSpesenart(spese: SpesenartItem): void {
    const bestätigungsForm = this.dialog.open(BestaetigungsFormComponent, {
      data: {
        title: 'pages.zeitverwaltung.deleteSpesenart.title',
        text: 'pages.zeitverwaltung.deleteSpesenart.text'
      },
    });
    bestätigungsForm.afterClosed().subscribe(result => {
      if (result === true){
        this.store.dispatch(deleteSpesenartStart({item: spese}));
      }
    });

  }

  public activateSpesenart(spese: SpesenartItem): void {
      this.store.dispatch(activateSpesenartStart({item: spese}));
  }

  public deactivateSpesenart(spese: SpesenartItem): void {
    this.store.dispatch(deactivateSpesenartStart({item: spese}));
  }

}
